<template>
  <w-modal
    v-model="show"
    class="modal-big"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-12">
        <w-monaco v-if="show" language="json" :model="$schema.schema" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/schema.schema';

const emptyData = () => ({ name: '', schema: '' });

// @vuese
// Modal dodania schemy
// @group Schema
export default {
  mixins: [manageMixin('schema', {}, emptyData), formMixin],
  schema,
  data() {
    return { model: {} };
  },
  computed: {
    title() {
      return this.id ? 'Edycja schemy' : 'Dodawanie schemy';
    }
  }
};
</script>
